import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import AboutUs from './pages/AboutUs'
import ContactUs from './pages/ContactUs'
import DigitalMarketing from './pages/DigitalMarketing'
import DigitalMarketingPpc from './pages/DigitalMarketingPpc'
import DigitalMarketingSeo from './pages/DigitalMarketingSeo'
import Home from './pages/Home'
import Service from './pages/Service'
import ServiceSms from './pages/ServiceSms'
import ServiceWappContent from './pages/ServiceWappContent'
import SocialFacebook from './pages/SocialFacebook'
import SocialLinedin from './pages/SocialLinedin'
import WhatsappBluetick from './pages/WhatsappBluetick'
import WhatsappBusiness from './pages/WhatsappBusiness'
import WhatsappChatbot from './pages/WhatsappChatbot'
import WhatsappClick from './pages/WhatsappClick'
import Pricing from './pages/Pricing'
import Privacypage from './pages/Privacypage'
import Blogs from "./pages/Blogs";
import DigitalMarketingAgencyMumbai from "./pages/DigitalMarketingAgencyMumbai";
import DigitalMarketingAgencyPune from "./pages/DigitalMarketingAgencyPune";
import DigitalMarketingAgencyCoimbatore from './pages/DigitalMarketingAgencyCoimbatore';
import DigitalMarketingAgencyKochi from './pages/DigitalMarketingAgencyKochi';
import DigitalMarketingAgencyKolkata from './pages/DigitalMarketingAgencyKolkata';
import DigitalMarketingAgencyTrivandrum from './pages/DigitalMarketingAgencyTrivandrum';
import DigitalMarketingAgencyBangalore from './pages/DigitalMarketingAgencyBangalore';
import DigitalMarketingAgencyHyderabad from './pages/DigitalMarketingAgencyHyderabad';
import DigitalMarketingAgencyDelhi from './pages/DigitalMarketingAgencyDelhi';
import DigitalMarketingAgencyAhmedabad from './pages/DigitalMarketingAgencyAhmedabad';
import DigitalMarketingAgencyNoida from './pages/DigitalMarketingAgencyNoida';
import DigitalMarketingAgencyChennai from './pages/DigitalMarketingAgencyChennai';

const Main = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about_us" element={<AboutUs />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact_us" element={<ContactUs />} />
          <Route path="/whatsapp_marketing" element={<Service />} />
          <Route path="/click_to_whatsappads" element={<WhatsappClick />} />
          <Route path="/whatsapp_chatbots" element={<WhatsappChatbot />} />
          <Route path="/whatsapp_business_api" element={<WhatsappBusiness />} />
          <Route path="/whatsapp_bluetick" element={<WhatsappBluetick />} />
          <Route path="/bulk_sms" element={<ServiceSms />} />
          <Route path="/rcs_messages" element={<ServiceWappContent />} />
          <Route path="/facebook_instagram_marketing" element={<SocialFacebook />} />
          <Route path="/linkedin_ads" element={<SocialLinedin />} />
          <Route path="/search_engine_optimization" element={<DigitalMarketingSeo />} />
          <Route path="/pay_per_click" element={<DigitalMarketingPpc />} />
          <Route path="/google_ads" element={<DigitalMarketing />} />
          <Route path="/privacy_policy" element={<Privacypage />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/digital-marketing-agency-mumbai" element={<DigitalMarketingAgencyMumbai />} />
          <Route path="/blogs/digital-marketing-agency-pune" element={<DigitalMarketingAgencyPune />} />
          <Route path="/blogs/digital-marketing-agency-coimbatore" element={<DigitalMarketingAgencyCoimbatore />} />
          <Route path="/blogs/digital-marketing-agency-kochi" element={<DigitalMarketingAgencyKochi />} />
          <Route path="/blogs/digital-marketing-agency-kolkata" element={<DigitalMarketingAgencyKolkata />} />
          <Route path="/blogs/digital-marketing-agency-trivandrum" element={<DigitalMarketingAgencyTrivandrum />} />
          <Route path="/blogs/digital-marketing-agency-bangalore" element={<DigitalMarketingAgencyBangalore />} />
          <Route path="/blogs/digital-marketing-agency-hyderabad" element={<DigitalMarketingAgencyHyderabad />} />
          <Route path="/blogs/digital-marketing-agency-delhi" element={<DigitalMarketingAgencyDelhi />} />
          <Route path="/blogs/digital-marketing-agency-ahmedabad" element={<DigitalMarketingAgencyAhmedabad />} />
          <Route path="/blogs/digital-marketing-agency-noida" element={<DigitalMarketingAgencyNoida />} />
          <Route path="/blogs/digital-marketing-agency-chennai" element={<DigitalMarketingAgencyChennai />} />

        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default Main